'use strict';

var BBCollection = Backbone.Collection;
var BBReset = BBCollection.prototype.reset;
var updateItems = function(collection, transform) {
    var updated = false;
    collection.each(function(item) {
        item.set('active', transform(item), {silent: true});
        updated = updated || !!item.changed;
    });
    return updated;
};
var updateNumSelected = function(collection, numSelected) {
    var eventsToTrigger = [];
    if (collection.numSelected !== numSelected) {
        collection.numSelected = numSelected;
        eventsToTrigger = [
            ['change', collection],
            ['change:numSelected', collection, numSelected],
        ];
    }
    return eventsToTrigger;
};

var triggerEvents = function(collection, events) {
    Odigeo._.each(events, function(event) {
        collection.trigger.apply(collection, event);
    });
};

var triggerUpdate = function(collection, updated) {
    if (updated) {
        collection.trigger('update', collection);
    }
};

module.exports = BBCollection.extend({
    initialize: function() {
        this.numSelected = 0;
    },
    reset: function(items) {
        var numSelected = Odigeo._.filter(items, function(checkboxItem) {
            return Odigeo._.isFunction(checkboxItem.get) ? checkboxItem.get('active') : checkboxItem.active;
        }).length;
        var events = updateNumSelected(this, numSelected);
        BBReset.call(this, items);
        triggerEvents(this, events);
    },
    turnOnById: function(id) {
        var models = [];
        var updated = updateItems(this, function(item) {
            var matches = item.get('id') === id;
            if (matches) {
                models.push(item);
            }
            return matches;
        });
        var events;
        if (models.length > 0) {
            this.trigger('turn-on', models);
        }
        events = updateNumSelected(this, models.length);
        triggerUpdate(this, updated);
        triggerEvents(events);
    },
    turnOnAll: function() {
        var updated = updateItems(this, Odigeo._.constant(true));
        this.trigger('turn-on-all');
        var events = updateNumSelected(this, this.length);
        triggerUpdate(this, updated);
        triggerEvents(this, events);
    },
    turnOffAll: function() {
        var updated = updateItems(this, Odigeo._.constant(false));
        var events = updateNumSelected(this, 0);
        this.trigger('turn-off-all');
        triggerUpdate(this, updated);
        triggerEvents(this, events);
    },
    toggle: function(id) {
        var model = this.get(id);
        var prop = 'active';
        var active = !model.get(prop);
        var events;
        model.set(prop, active);
        events = updateNumSelected(this, this.numSelected + (active ? 1 : -1));
        this.trigger('toggle', model);
        this.trigger('update', this);
        triggerEvents(this, events);
        return model;
    },
    turnOnByIdList: function(idList) {
        updateItems(this, function(item) {
            return idList.includes(item.get('id'));
        });
        const numSelected = this.models.filter((e) => {
            return e.get('active');
        });
        const events = updateNumSelected(this, numSelected.length);
        this.trigger('updateBySelected');
        this.trigger('update', this);
        triggerEvents(this, events);
    },
});
